"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchTabsPreview = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _search = require("../../../constants/search");

var SearchTabsPreview = function SearchTabsPreview(_ref) {
  var _ref$searchType = _ref.searchType,
      searchType = _ref$searchType === void 0 ? _search.SEARCH_TYPE_NAMES.PACKAGE : _ref$searchType,
      _onClick = _ref.onClick,
      availableSearchTypes = _ref.availableSearchTypes;
  var searchTypesArray = availableSearchTypes ? _search.SEARCH_TYPES.filter(function (_ref2) {
    var name = _ref2.name;
    return availableSearchTypes.includes(name);
  }) : _search.SEARCH_TYPES;
  return /*#__PURE__*/_react["default"].createElement(Tabs, null, searchTypesArray.map(function (_ref3) {
    var label = _ref3.label,
        name = _ref3.name;
    return /*#__PURE__*/_react["default"].createElement(Tab, {
      key: name,
      $isActive: name === searchType,
      onClick: function onClick() {
        return _onClick === null || _onClick === void 0 ? void 0 : _onClick(name);
      }
    }, label, name === _search.SEARCH_TYPE_NAMES.HOTEL ? /*#__PURE__*/_react["default"].createElement(StyledNewIcon, null, "NEW") : null);
  }));
};

exports.SearchTabsPreview = SearchTabsPreview;

var Tabs = _styledComponents["default"].div.withConfig({
  displayName: "SearchTabsPreview__Tabs",
  componentId: "sc-yuwy09-0"
})(["display:flex;"]);

var Tab = _styledComponents["default"].div.withConfig({
  displayName: "SearchTabsPreview__Tab",
  componentId: "sc-yuwy09-1"
})(["display:flex;border-radius:4px 4px 0px 0px;padding:4px 8px;cursor:pointer;", ""], function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive ? "background: #525252; color: white" : "color: #919499";
});

var StyledNewIcon = _styledComponents["default"].div.withConfig({
  displayName: "SearchTabsPreview__StyledNewIcon",
  componentId: "sc-yuwy09-2"
})(["font-weight:50;letter-spacing:0.1em;margin-left:4px;font-size:8px;color:white;background:linear-gradient(90deg,#ff9c41 0%,#f82c69 100%);border-radius:4px;padding:4px;"]);